export default "__VITE_ASSET__OwYvIiJY__"